import request from './option'

// 注册:data:{username,password,mobile}
export function register(data) {
  return request({
    url: '/index.php',
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data',
    },
    params: {
      g: 'Api',
      m: 'User',
      a: 'register',
    },
    data: data
  })
}




// 登录:data:{mobile,password}
export function login(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'User',
      a: 'login',
    },
    data: data
  })
}


// 获取新首页数据(美食和景点轮播图)
export function getIndexImg(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getIndexImg',
    },
    data: data
  })
}
// 获取问答数据
export function getQuestion(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getQuestion',
    },
    data: data
  })
}


// 获取评论数据
export function getEvaluate(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getEvaluate',
    },
    data: data
  })
}

// 意向表
export function dreamPost(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'dreamPost',
    },
    data: data
  })
}

// 获取首页信息
export function getHomeInfo(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getMenubar',
    },
    data: {}
  })
}

// 线路类别
export function getLineType(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getLineType',
    },
    data: {}
  })
}



// 获取线路类别下对应的线路列表
export function getLineList(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getLineList',
    },
    data: data
  })
}

// 底部菜单对应的页面数据
export function getDibuContent(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getDibuContent',
    },
    data: data
  })
}

// 推荐线路数据
export function getRecommendList(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getRecommendList',
    },
    data: data
  })
}


// 搜索接口
export function getSearchPost(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'search_post',
    },
    data: data
  })
}

// 轮播图（首页）
export function getSlideCat(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getSlideCat',
    },
    data: data
  })
}
// 轮播图（分类）
export function getSlideCat_fenlei(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getSlideCat_fenlei',
    },
    data: data
  })
}



// 报名
export function sendRegistration(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'baoming',
    },
    data: data
  })
}


// 线路详情
export function getDetail(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getDetail',
    },
    data: data
  })
}


// 线路详情
export function getOrderDetail(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'User',
      a: 'user_list',
    },
    data: data
  })
}


export function getLineTypeWithLines(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'getLineTypeWithLines',
    },
    data: data
  })
}
// 获取验证码
export function getVerifycode(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'get_verifycode',
    },
    data: data
  })
}



// 验证验证码
export function checkVerify(data) {
  return request({
    url: '/index.php',
    method: 'post',
    params: {
      g: 'Api',
      m: 'Travel',
      a: 'check_verify',
    },
    data: data
  })
}


